import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Observable, Subject, Subscription } from 'rxjs';
import { DrawerItemSubtitle } from '../../component-library/object-drawer/drawer-item-subtitle';
import { ObjectDrawerParameters } from '../../component-library/object-drawer/object-drawer-parameters';
import { SectionContainerConfig } from '../../component-library/section-container/section-container-config';
import { SectionContainerProviderService } from '../../component-library/section-container/section-container-provider-service';
import { BackendPaginationService } from '../../core/backend-pagination.service';
import { PermissionsService } from '../../core/permissions.service';
import { TableTemplate } from '../../viewmodels/admin/table-attribute-template/table-template';

@Injectable({
  providedIn: 'root',
})
export class TableAttributeTemplatesProviderService implements SectionContainerProviderService {
  public breadcrumbChangedSub: Subscription = undefined;
  private config: SectionContainerConfig;

  public constructor(
    private i18NextPipe: I18NextPipe,
    private backendPaginationService: BackendPaginationService,
    private permissionsService: PermissionsService
  ) {
    this.subscribeToPermissionsChanges();
  }

  public getConfig(): SectionContainerConfig {
    const config = new SectionContainerConfig();

    config.hasBreadcrumbs = false;
    config.itemSubtitles = [new DrawerItemSubtitle('description')];
    config.itemIdField = 'tableTemplateId';
    config.itemTitleField = 'name';
    config.title = this.i18NextPipe.transform('TableAttributeTemplatesProviderService.Name');
    config.itemTypeName = this.i18NextPipe.transform('TableAttributeTemplatesProviderService.Lookup');
    config.hasFilters = false;
    config.showTreeView = false;
    config.showActionsWithoutSelection = true;
    this.setAddButtonVisibility(config);
    this.config = config;
    return config;
  }

  public getFilteredTreeNodes(): Observable<any[]> {
    throw new Error('Method not implemented');
  }

  public getTreeRootData(): Observable<any[]> {
    throw new Error('Method not implemented');
  }

  public getData(first: number, pageSize: number, params: ObjectDrawerParameters): Observable<any> {
    params.skip = first;
    params.take = pageSize;

    return this.backendPaginationService.paginateWithParameters<TableTemplate>(TableTemplate, params, first, pageSize, false);
  }

  public getTotalItemCount(params: ObjectDrawerParameters): Observable<any> {
    return this.backendPaginationService.getCountWithParameters<TableTemplate>(TableTemplate, params, false);
  }

  public getTreeChildData(): Observable<any[]> {
    throw new Error('Method not implemented');
  }

  public getBreadcrumbTrail(): Subject<any[]> {
    throw new Error('Method not implemented');
  }

  public getObjectDrawerFilters(): Observable<any> {
    throw new Error('Method not implemented');
  }

  public onBreadcrumbsDestroy(): void {
    throw new Error('Method not implemented');
  }

  private subscribeToPermissionsChanges(): void {
    this.permissionsService.userPermissionKeyValuePairs.subscribe(() => {
      this.setAddButtonVisibility(this.config);
    });
  }

  private setAddButtonVisibility(config: SectionContainerConfig): void {
    if (!config) {
      return;
    }

    const { adminHierarchyTemplateCreate: canCreate } = this.permissionsService.userPermissionKeys;
    config.enableAdd = this.permissionsService.checkUserHasPermissions(canCreate);
  }
}
